import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "NoResultsRecommendations" }
const _hoisted_2 = {
  key: 0,
  class: "NoResultsText"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "SuggestionSection" }
const _hoisted_5 = {
  key: 2,
  class: "OtherInterestingForYou"
}
const _hoisted_6 = {
  key: 3,
  class: "RecommendationsContainer"
}
const _hoisted_7 = ["data-identifier", "data-filter-countries", "data-filter-disciplines"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectedFilters = _resolveComponent("SelectedFilters")!
  const _component_DisciplineSuggestions = _resolveComponent("DisciplineSuggestions")!
  const _component_LocationSuggestions = _resolveComponent("LocationSuggestions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.resultsCount === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "No results for " + _toDisplayString(_ctx.pageTitle), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.resultsCount <= _ctx.maxNumberOfResultsForSuggestions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "RemoveFiltersSuggestionsTitle" }, "Try removing some of your filters", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_SelectedFilters, {
              options: _ctx.selectedFiltersOptions,
              displaySection: _ctx.trackingDisplaySection
            }, null, 8 /* PROPS */, ["options", "displaySection"])
          ]),
          _createVNode(_component_DisciplineSuggestions),
          _createVNode(_component_LocationSuggestions)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.resultsCount === 0)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "Interesting programmes for you"))
      : _createCommentVNode("v-if", true),
    (_ctx.resultsCount === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "Recommendations",
            "data-identifier": _ctx.dataIdentifier,
            "data-recommendation-type": "programmes",
            "data-template": "carousel",
            "data-page": "search",
            "data-filter-countries": _ctx.countryFilterValues,
            "data-filter-disciplines": _ctx.selectedDiscipline
          }, null, 8 /* PROPS */, _hoisted_7)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}